import { I18nFieldWrapper, JsonCodeMirrorField, useI18nForm, useLanguageIndex } from "@dgs/core";
import { FC } from "react";

export const ProductTranslationField: FC = () => {
	const { currentLanguage } = useI18nForm();
	const currentLanguageIdx = useLanguageIndex(currentLanguage);

	return (
		<I18nFieldWrapper name="value">
			<JsonCodeMirrorField name={`translations.${currentLanguageIdx}.value`} />
		</I18nFieldWrapper>
	);
};
